import React from 'react'
import css from "./ButtonLoader.module.css";

/**
 * In the future could be extended to pick spinner color depends on the props.
 */
const ButtonLoaderComponent = () => ( <div className={css.loader} /> );

export default ButtonLoaderComponent;
